import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { PageTitle } from "@/components/app/ui";
import { StatusPill } from "@/components/site/Section";
import { api, errMsg } from "@/lib/api";

export default function AppIntegrations() {
  const [items, setItems] = useState([]);
  const [params] = useSearchParams();
  useEffect(() => { const o = params.get("oauth"); if (o) (o.endsWith("connected") ? toast.success : toast.error)(o.replace("_", " ")); }, [params]);
  const liveConnect = async (x) => {
    try { const { data } = await api.get(`/oauth/${x.provider}/authorize`); window.location.assign(data.authorize_url); } catch (e) { toast.error(errMsg(e)); }
  };
  const liveDisconnect = async (x) => { try { await api.delete(`/oauth/${x.provider}`); toast.success("Disconnected"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const load = () => api.get("/app/integrations").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const toggle = async (x) => {
    try { await api.post(`/app/integrations/${x.key}/${x.connected ? "disconnect" : "connect"}`); toast.success(x.connected ? "Disconnected" : "Connected (demo)"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="app-integrations-page">
      <PageTitle title="Integrations" copy="Connect channels to publish and measure. Demo connections simulate publishing while platform API approvals are completed." />
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {items.map((x) => (
          <div key={x.key} className="card-box p-6 flex flex-col" data-testid={`app-integration-${x.key}`}>
            <div className="flex items-start justify-between">
              <div className="h-11 w-11 rounded-xl bg-brand flex items-center justify-center font-display font-bold text-white">{x.name[0]}</div>
              <StatusPill status={x.live_connected ? "Live" : x.status === "demo" ? "Demo" : "Coming Soon"} />
            </div>
            <h3 className="mt-4 font-semibold">{x.name}</h3>
            <div className="text-xs text-muted-foreground">{x.category}</div>
            <div className="mt-4 flex-1 text-xs">{x.live_connected ? <span className="text-[#10b981]">● Live: {x.account_name}</span> : x.connected ? <span className="text-[#10b981]">● Connected (demo)</span> : <span className="text-muted-foreground">Not connected</span>}
              {x.provider && !x.live_available && <div className="mt-1 text-muted-foreground">Live posting activates once Sliance adds the {{ meta: "Meta", linkedin: "LinkedIn", x: "X" }[x.provider]} app keys.</div>}</div>
            {x.provider && x.live_available && (
              <button onClick={() => (x.live_connected ? liveDisconnect(x) : liveConnect(x))} data-testid={`integration-live-${x.key}`} className="mt-4 btn-brand !py-2 text-xs">{x.live_connected ? "Disconnect live account" : `Connect ${{ meta: "Meta", linkedin: "LinkedIn", x: "X" }[x.provider]} account`}</button>
            )}
            {!(x.provider && x.live_available) && <button disabled={x.status === "coming_soon"} onClick={() => toggle(x)} data-testid={`integration-toggle-${x.key}`}
              className={`mt-4 ${x.connected ? "btn-ghost" : "btn-brand"} !py-2 text-xs disabled:opacity-40 disabled:cursor-not-allowed`}>
              {x.status === "coming_soon" ? "Coming soon" : x.connected ? "Disconnect" : "Connect (demo)"}
            </button>}
          </div>
        ))}
      </div>
    </div>
  );
}
